import { useEffect } from 'react';
import { getCookie } from '../utils/cookies.js';
import 'cookies-next';
import '../cookies-l-jEMp6P.js';
import '../currency-_kacFJHO.js';
import '../language-BHHwgtQp.js';
import '../payment-a4IKjS7g.js';
import '../utils/isBot.js';

// Custom hook: useConsentModeListener
// Purpose: To listen for changes in the consent mode on the webpage and execute a callback when changes are detected.
const useConsentModeListener = (callback) => {
    useEffect(() => {
        const checkConsentMode = () => {
            var _a, _b;
            const consentCookie = getCookie('CookieConsent');
            if (consentCookie) {
                callback(consentCookie);
            }
            if (window.ConsentMode && ((_a = window.ConsentMode) === null || _a === void 0 ? void 0 : _a.consent)) {
                callback(window.ConsentMode.consent);
            }
            if (window.CookieConsent && ((_b = window.CookieConsent) === null || _b === void 0 ? void 0 : _b.consent)) {
                callback(window.CookieConsent.consent);
            }
        };
        const observer = new MutationObserver(mutationsList => {
            mutationsList.forEach(mutation => {
                var _a, _b;
                if (mutation.type === 'childList' || mutation.type === 'attributes') {
                    if ((window.ConsentMode && ((_a = window.ConsentMode) === null || _a === void 0 ? void 0 : _a.consent)) ||
                        (window.CookieConsent && ((_b = window.CookieConsent) === null || _b === void 0 ? void 0 : _b.consent))) {
                        checkConsentMode();
                    }
                }
            });
        });
        const observerOptions = {
            childList: true,
            subtree: true,
            attributes: true,
        };
        observer.observe(document.documentElement, observerOptions);
        checkConsentMode();
        return () => {
            observer.disconnect();
        };
    }, [callback]);
};

export { useConsentModeListener as default };
//# sourceMappingURL=useConsentModeListener.js.map
